function pad2(value) {
  return String(value).padStart(2, "0");
}

function formatParts(day, month, year) {
  if (!day || !month || !year) return "";
  return `${pad2(day)}-${pad2(month)}-${String(year)}`;
}

export function formatDisplayDate(value) {
  if (value == null) return "";

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return formatParts(value.getDate(), value.getMonth() + 1, value.getFullYear());
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const ymdMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (ymdMatch) {
    return `${ymdMatch[3]}-${ymdMatch[2]}-${ymdMatch[1]}`;
  }

  const dmyMatch = raw.match(/^(\d{2})-(\d{2})-(\d{4})(?:[T\s].*)?$/);
  if (dmyMatch) {
    return `${dmyMatch[1]}-${dmyMatch[2]}-${dmyMatch[3]}`;
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return formatParts(parsed.getDate(), parsed.getMonth() + 1, parsed.getFullYear());
  }

  return raw;
}

export function formatDisplayDateTime(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const match = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s])(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/
  );
  if (match) {
    return `${match[3]}-${match[2]}-${match[1]} ${match[4]}:${match[5]}`;
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    const datePart = formatDisplayDate(parsed);
    const timePart = `${pad2(parsed.getHours())}:${pad2(parsed.getMinutes())}`;
    return `${datePart} ${timePart}`;
  }

  return raw;
}

export function toComparableYmd(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const ymdMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (ymdMatch) {
    return `${ymdMatch[1]}-${ymdMatch[2]}-${ymdMatch[3]}`;
  }

  const dmyMatch = raw.match(/^(\d{2})-(\d{2})-(\d{4})(?:[T\s].*)?$/);
  if (dmyMatch) {
    return `${dmyMatch[3]}-${dmyMatch[2]}-${dmyMatch[1]}`;
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return `${parsed.getFullYear()}-${pad2(parsed.getMonth() + 1)}-${pad2(parsed.getDate())}`;
  }

  return raw;
}
